import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function HeroBackgroundOverlay() {
  return <section data-section-id="255918" id="hero-section" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-secondary !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/IMG_3609-scaled.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/IMG_3609-scaled.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/IMG_3609-scaled.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/IMG_3609-scaled.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/newsom-before-1.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/newsom-before-1.png)]">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/mulching_service_hero.png')]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-secondary/60" />

      {}
      <div className="relative z-10 bg-secondary/90 backdrop-blur-sm p-8 md:p-16 rounded-lg shadow-2xl max-w-4xl mx-4 w-full flex flex-col items-center text-center border border-accent-cream/20">
        
        <h1 className="font-default text-3xl md:text-5xl lg:text-6xl font-bold text-[#F2E8CF] tracking-tight mb-6 relative pb-4">
          Get in Touch with Chipper Mulching Co.
          <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1.5 bg-primary rounded-md" />
        </h1>

        <p className="font-sans text-base md:text-lg text-[#F2E8CF]/90 mb-10 max-w-2xl leading-relaxed">
          Questions? Ready for a free estimate? We'd love to hear from you and help transform your landscape today.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-10 w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-md px-8 text-base bg-primary hover:bg-primary/90 text-white">
            <Link to="#contact-form">
              Get a Free Estimate
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md px-8 text-base bg-transparent border-[#F2E8CF]/40 text-[#F2E8CF] hover:bg-[#F2E8CF]/10">
            <Link to="/Services/">
              Our Services
            </Link>
          </Button>
        </div>

        {}
        <nav className="flex flex-wrap justify-center gap-6 text-sm font-sans text-[#F2E8CF]/70 pt-6 border-t border-[#F2E8CF]/20 w-full">
          <Link to="/HomePage" className="hover:text-primary transition-colors">
            Home
          </Link>
          <Link to="/ServicesPage" className="hover:text-primary transition-colors">
            Services
          </Link>
          <Link to="/ContactUsPage" className="hover:text-primary transition-colors">
            Contact
          </Link>
        </nav>
        
      </div>
    </section>;
}